import React, { useEffect, useState } from "react";
import MyContext from "../../../api/context/my-context";
import ErrorList from "./errorList";

const SideMenuProcessErrorModal = (errorList = []) => {
  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="side-menu-process-error-modal"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <span className="process-error-modal"></span>
              Fout in uitvoering
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <p className="">
              Deze werkregels zijn niet verzonden. {/*omdat het betreffende werkplan
              niet compleet is.*/}
            </p>
            <div className="modal-scroll">
              <div className="process-error-grp">
                <MyContext.Consumer>
                  {(context) => (
                    <div>
                      <ErrorList
                        errorList={context.storeProcess.errorRowCodes}
                      />
                    </div>
                  )}
                </MyContext.Consumer>
              </div>
            </div>
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
};

export default SideMenuProcessErrorModal;
